module.exports = __webpack_public_path__ + "static/media/FranklinGothicHeavyRegular.59e78317.ttf";